import "@/App.css";
import { BrowserRouter, Routes, Route, useParams, Link } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { ArrowLeft } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { Button } from "@/components/ui/button";
import { HeaderNav } from "@/components/HeaderNav";
import { PublicVideoView } from "@/components/PublicVideoView";
import { QrWorkspace } from "@/components/QrWorkspace";
import { QRCodeManager } from "@/components/QRCodeManager";
import { AuthProvider } from "@/context/AuthContext";

const Home = () => (
  <>
    <HeaderNav />
    <main className="mx-auto max-w-6xl px-5 py-10 sm:px-8 sm:py-14">
      <section className="mb-10 max-w-2xl">
        <span className="mb-4 inline-block rounded-full bg-primary/10 px-3 py-1 text-xs font-mono uppercase tracking-widest text-primary">
          QR Code dinâmico e permanente
        </span>
        <h1 className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          Um QR Code que você imprime uma vez.
        </h1>
        <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
          Seu QR Code e o link público nunca mudam. Você troca o vídeo de destino
          quando quiser — o material impresso continua válido para sempre.
        </p>
      </section>

      <QrWorkspace qrId="main" />
      <QRCodeManager />
    </main>
  </>
);

const ManagePage = () => {
  const { qrId } = useParams();
  return (
    <>
      <HeaderNav />
      <main className="mx-auto max-w-6xl px-5 py-10 sm:px-8 sm:py-14">
        <Link to="/">
          <Button variant="ghost" size="sm" data-testid="manage-back-button" className="mb-6 -ml-2 text-muted-foreground">
            <ArrowLeft className="mr-2 h-4 w-4" /> Voltar para todos os QR Codes
          </Button>
        </Link>
        <section className="mb-8 max-w-2xl">
          <span className="mb-3 inline-block rounded-full bg-primary/10 px-3 py-1 text-xs font-mono uppercase tracking-widest text-primary">
            Configurar QR Code
          </span>
          <h1 className="font-display text-2xl font-extrabold leading-tight tracking-tight sm:text-3xl">
            Este é um QR Code independente.
          </h1>
          <p className="mt-3 text-base leading-relaxed text-muted-foreground">
            Baixe, copie o link, publique o vídeo e configure os contatos — tudo separado dos outros QR Codes.
          </p>
        </section>
        <QrWorkspace qrId={qrId} />
      </main>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/manage/:qrId" element={<ManagePage />} />
              <Route
                path="/v/:id"
                element={
                  <>
                    <HeaderNav />
                    <PublicVideoView />
                  </>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
